<template>
  <div class="setting-container" v-show="loadingOver">
    <w-nav-bar nav_title="求职设置" @mobileLeftBtn="back"/>
    <div class="setting-list">
      <div class="flex-between setting-item" v-for="(item, index) in settingList" :key="index" @click="toPage(item)">
        <div class="flex-start">
          <span class="iconfont" :class="item.icon"></span>
          <span>{{ item.title }}</span>
        </div>
        <span class="iconfont iconchevron-right"></span>
      </div>
    </div>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'
  import { userMixin } from '../../assets/js/mixin/user'
  import { envMixin } from '../../assets/js/mixin/global'
	import { mapState, mapActions } from 'vuex'

	export default {
		name: 'setting',
		mixins: [ userMixin, envMixin ],
		data () {
			return {
				settingList: [
					{ title: '求职意向', icon: 'iconshoutixiang', path: '/job/intentions?jobs=1' },
					{ title: '网申提醒', icon: 'iconbell', path: '/jobs/campus/remind' }
				],
        loadingOver: false
			}
		},
		mounted () {
			this.initSet()
		},
		computed: {
		},
		watch: {},
		components: {
			WNavBar
		},
		methods: {
			toPage ({ path }) {
				this.$router.push(path)
			},
			back () {
				this.$router.replace("/jobs/recommend")
			},
			async initSet () {
        await this.getUserData()
        //不是学生/支付宝/夸克/uc，去掉网申提醒
				if (!this.userData.is_student || this.isAlipayClient || this.isUCClient || this.isQuaReClient ){
          this.settingList.splice(1, 1)
        }
        this.loadingOver = true
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .setting-container {
    min-height: calc(var(--vh, 1vh) * 100);
    @include mobile-container(52px, 1px);
    .setting-list {
      padding: 0 24px;
      .setting-item {
        height: 50px;
        border-bottom: 1px solid #f9f9f9;
        font-size: $font-size-medium-x;
        color: $color-title;
        .iconshoutixiang, .iconbell {
          margin-right: 16px;
          color: $color-title;
        }
        .iconbell {
          font-weight: bold;
          font-size: 18px;
        }
        .iconchevron-right {
          font-weight: 600;
          color: #BDBDBD;
        }
      }
    }
  }
</style>
